/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Voice_DeepInputs */

const en_dialog_voice_deep = /** @type {(inputs: Dialog_Voice_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deep voice`)
};

const es_dialog_voice_deep = /** @type {(inputs: Dialog_Voice_DeepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz profunda`)
};

/**
* | output |
* | --- |
* | "Deep voice" |
*
* @param {Dialog_Voice_DeepInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_voice_deep = /** @type {((inputs?: Dialog_Voice_DeepInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Voice_DeepInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_voice_deep(inputs)
	return en_dialog_voice_deep(inputs)
});